import { Suspense, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./components/home";
import { AuthProvider } from "./components/auth/AuthProvider";
import Login from "./components/auth/Login";
import Register from "./components/auth/Register";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import AdminDashboard from "./pages/Dashboard/AdminDashboard";
import StudentDashboard from "./pages/Dashboard/StudentDashboard";
import InstructorDashboard from "./pages/Dashboard/InstructorDashboard";
import StaffDashboard from "./pages/Dashboard/StaffDashboard";
import Overview from "./pages/Admin/Overview";
import Users from "./pages/Admin/Users";
import Courses from "./pages/Admin/Courses";
import Vehicles from "./pages/Admin/Vehicles";
import Schedule from "./pages/Admin/Schedule";
import AdminPayments from "./pages/Admin/AdminPayments";
import Analytics from "./pages/Admin/Analytics";
import Content from "./pages/Admin/Content";
import Settings from "./pages/Admin/Settings";
import StaffActiveSchedules from "./pages/Dashboard/StaffActiveSchedules";
import StaffTimeSlots from "./pages/Dashboard/StaffTimeSlots";
import StaffScheduleRequests from "./pages/Dashboard/StaffScheduleRequests";
import StaffRescheduleRequests from "./pages/Dashboard/StaffRescheduleRequests";
import StaffScheduleManagement from "./pages/Dashboard/StaffScheduleManagement";
import StaffUploadCertificates from "./pages/Dashboard/StaffUploadCertificates";
import StaffEnrollments from "./pages/Dashboard/StaffEnrollments";
import StaffEnrollmentManagement from "./pages/Dashboard/StaffEnrollmentManagement";
import StaffLicenseRequests from "./pages/Dashboard/StaffLicenseRequests";
import StaffNotifications from "./pages/Dashboard/StaffNotifications";
import StaffWalkInStudents from "./pages/Dashboard/StaffWalkInStudents";
import { auth } from "./lib/firebase";
import StaffLayout from "./pages/Dashboard/StaffLayout";
import AdminLicenseCodes from "./pages/Admin/AdminLicenseCodes";
import Instructors from "./pages/Admin/Instructors";
import ORManagement from "./pages/Admin/ORManagement";

function App() {
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      if (user) {
        user.getIdTokenResult().then(res => {
          console.log("Custom claims:", res.claims);
        });
      } else {
        console.log("No user is signed in.");
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <AuthProvider>
      <Suspense fallback={<p>Loading...</p>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard/admin" element={<ProtectedRoute allowedRoles={["admin"]}><AdminDashboard /></ProtectedRoute>}>
            <Route path="overview" element={<Overview />} />
            <Route path="users" element={<Users />} />
            <Route path="instructors" element={<Instructors />} />
            <Route path="courses" element={<Courses />} />
            <Route path="vehicles" element={<Vehicles />} />
            <Route path="schedule" element={<Schedule />} />
            <Route path="payments" element={<AdminPayments />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="content" element={<Content />} />
            <Route path="settings" element={<Settings />} />
            <Route path="license-codes" element={<AdminLicenseCodes />} />
            <Route path="or" element={<ORManagement />} />
            <Route index element={<Overview />} />
          </Route>
          <Route path="/dashboard/staff" element={<ProtectedRoute allowedRoles={["staff"]}><StaffLayout /></ProtectedRoute>}>
            <Route index element={<StaffDashboard />} />
            <Route path="enrollment-management" element={<StaffEnrollmentManagement />} />
            <Route path="time-slots" element={<StaffTimeSlots />} />
            <Route path="schedule-management" element={<StaffScheduleManagement />} />
            <Route path="certificates" element={<StaffUploadCertificates />} />
            <Route path="license-requests" element={<StaffLicenseRequests />} />
            <Route path="notifications" element={<StaffNotifications />} />
            {/* Legacy routes for backward compatibility */}
            <Route path="enrollments" element={<StaffEnrollments />} />
            <Route path="walk-in-students" element={<StaffWalkInStudents />} />
            <Route path="schedule" element={<StaffScheduleManagement />} />
            <Route path="schedule-requests" element={<StaffScheduleManagement />} />
            <Route path="reschedule" element={<StaffScheduleManagement />} />
          </Route>
          <Route path="/dashboard/student" element={<ProtectedRoute allowedRoles={["student"]}><StudentDashboard /></ProtectedRoute>} />
          <Route path="/dashboard/instructor" element={<ProtectedRoute allowedRoles={["instructor"]}><InstructorDashboard /></ProtectedRoute>} />
        </Routes>
      </Suspense>
    </AuthProvider>
  );
}

export default App;
